// Types and Interfaces
import MenuCategory from "../../interfaces/MenuCategory";
// Images
import grilledChickenImage from "../../../assets/images/food/grilled-chicken.webp";
import babyBackRibsImage from "../../../assets/images/food/baby-back-ribs.webp";
import carneAsadaImage from "../../../assets/images/food/carne-asada.webp";
import tacosImage from "../../../assets/images/food/tacos-2.webp";
import pupusaImage from "../../../assets/images/food/pupusas.webp";
import quesadillasImage from "../../../assets/images/food/quesadillas.webp";
import mojarrasImage from "../../../assets/images/food/mojarra-frita.webp";
import pastelitosImage from "../../../assets/images/food/pastelitos.webp";
import tortillasImage from "../../../assets/images/food/tortillas.webp";
import beveragesImage from "../../../assets/images/food/aguas-frescas.webp";

const menuEN: MenuCategory[] = [
    {
        name: "Grilled Chicken",
        description: "Flavorful and juicy chicken with spices grilled over charcoal.",
        image: grilledChickenImage,
        options: [
            { name: "Combo", price: 16, description: "A perfect portion of grilled chicken with sides." },
            { name: "Family Combo", price: 31, description: "Share the flavor with the whole family." },
        ],
    },
    {
        name: "Grilled Pork Ribs",
        description: "Succulent charcoal-grilled baby back ribs with BBQ sauce.",
        image: babyBackRibsImage,
        options: [
            { name: "Combo", price: 16, description: "Tender ribs smothered in rich BBQ sauce." },
            { name: "Family Combo", price: 61, description: "A feast of ribs for everyone to enjoy." },
        ],
    },
    {
        name: "Carne Asada",
        description: "Juicy steak grilled over charcoal served with rice and beans.",
        image: carneAsadaImage,
        options: [
            { name: "Combo", price: 20, description: "Juicy steak with traditional sides, truly a classic." },
        ],
    },
    {
        name: "Tacos",
        description: "Delicious tacos made fresh with authentic flavors.",
        image: tacosImage,
        options: [
            {
                name: "Pollo Asado (Chicken) x3",
                price: 10,
                description: "Tender grilled chicken with savory seasoning.",
            },
            {
                name: "Al Pastor (Pork) x3",
                price: 10,
                description: "Juicy pork marinated with spices and pineapple.",
            },
            {
                name: "Carne Asada (Beef) x3",
                price: 10,
                description: "Flavorful grilled steak with a smoky char.",
            },
            {
                name: "Shrimp",
                price: 4,
                description: "Succulent shrimp with a zesty kick.",
            },
        ],
    },
    {
        name: "Pupusas",
        description: "Authentic Honduran pupusas, stuffed with delicious fillings.",
        image: pupusaImage,
        options: [
            {
                name: "Chicharron (Fried Pork Belly) x3",
                price: 10,
                description: "Crispy pork goodness in every bite.",
            },
            {
                name: "Pollo Asado (Chicken) x3",
                price: 10,
                description: "Tender chicken perfectly seasoned and stuffed.",
            },
            {
                name: "Beans x3",
                price: 10,
                description: "Creamy and hearty beans with a traditional touch.",
            },
            {
                name: "Cheese x3",
                price: 10,
                description: "Melted cheese for a gooey, savory treat.",
            },
            {
                name: "Mixed x3",
                price: 10,
                description: "A delicious combination of cheese, beans, and meat.",
            },
        ],
    },
    {
        name: "Quesadillas",
        description: "Fresh Quesadillas with Corn Tortillas and Gooey Cheese.",
        image: quesadillasImage,
        options: [
            { name: "Chicken", price: 8, description: "Tender chicken with melted cheese in every bite." },
            { name: "Al Pastor", price: 8, description: "Sweet and savory marinated pork with gooey cheese." },
            { name: "Carne Asada", price: 8, description: "Grilled steak with a cheesy, crispy finish." },
        ],
    },
    {
        name: "Mojarra Frita",
        description: "Crispy fried Mojarra, seasoned to perfection.",
        image: mojarrasImage,
        options: [
            { name: "Fish", price: 10, description: "Perfectly fried, crispy Mojarra seasoned just right." },
        ],
    },
    {
        name: "Pastelitos",
        description: "Fresh Honduran style pastelitos, crispy and delicious.",
        image: pastelitosImage,
        options: [
            { name: "Chicken", price: 7, description: "Savory chicken wrapped in flaky pastry." },
            { name: "Al Pastor", price: 10, description: "Marinated pork in a golden, crispy shell." },
            { name: "Carne Asada", price: 10, description: "Tender steak wrapped in a delicious crust." },
        ],
    },
    {
        name: "Tortillas",
        description: "Handmade corn tortillas, perfect for any meal.",
        image: tortillasImage,
        options: [
            { name: "1/2 Pound", price: 3, description: "Freshly made half-pound of tortillas." },
            { name: "1 Pound", price: 5, description: "A full pound of soft, hand-pressed tortillas." },
        ],
    },
    {
        name: "Beverages",
        description: "Something to quench your thirst.",
        image: beveragesImage,
        options: [
            { name: "Canned Soda", price: 2, description: "Classic soda in a convenient can." },
            { name: "Glass Bottle of Soda", price: 3, description: "Refreshing soda served in a glass bottle." },
            {
                name: "Agua Fresca",
                price: 5,
                description:
                    "Sweet, refreshing, and perfectly chilled — choose from cantaloupe, pineapple, watermelon, horchata, jamaica, or limeade. 100% natural ingredients.",
            },
        ],
    },
];

export const seoTitleEn = "La Estrellita | Menu";

export default menuEN;
